import { Palette, Sparkles } from "lucide-react";
import { CanvaLogo, FrameIOLogo } from "@/components/BrandLogos";
import { skills } from "@/data/portfolio";

const Mark = ({ skill }) => {
    if (skill.logo === "canva") return <CanvaLogo className="h-7 w-7 shrink-0" />;
    if (skill.logo === "frameio") return <FrameIOLogo className="h-7 w-7 shrink-0" />;
    if (skill.icon === "sparkles")
        return (
            <span className="grid h-7 w-7 place-items-center rounded-md border border-flame/30 bg-flame/10 text-flame">
                <Sparkles size={13} />
            </span>
        );
    if (skill.icon === "palette")
        return (
            <span className="grid h-7 w-7 place-items-center rounded-md border border-flame/30 bg-flame/10 text-flame">
                <Palette size={13} />
            </span>
        );
    return (
        <span
            className="grid h-7 w-7 place-items-center rounded-md text-[10px] font-semibold"
            style={{ backgroundColor: skill.bg, color: skill.fg }}
        >
            {skill.mark}
        </span>
    );
};

const SkillsMarquee = () => {
    const copies = [0, 1, 2, 3];
    return (
        <section
            data-testid="skills-marquee"
            aria-label="Software and skills"
            className="relative border-y border-white/5 bg-ink-2/60 py-6"
        >
            <div className="marquee-mask overflow-hidden">
                <div className="animate-marquee flex w-max items-center">
                    {copies.map((copy) => (
                        <div
                            key={copy}
                            aria-hidden={copy > 0}
                            className="flex items-center"
                        >
                            {skills.map((skill) => (
                                <div
                                    key={`${copy}-${skill.name}`}
                                    data-testid={`skill-item-${skill.name.toLowerCase().replace(/[\s.]+/g, "-")}`}
                                    className="flex items-center gap-3 px-8"
                                >
                                    <Mark skill={skill} />
                                    <span className="whitespace-nowrap text-sm font-medium text-slate-400">
                                        {skill.name}
                                    </span>
                                    <span
                                        className="ml-8 h-1 w-1 rounded-full bg-flame/60"
                                        aria-hidden="true"
                                    />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SkillsMarquee;
